import toItineraryPredicate from '../../../Filters/queries/toItineraryPredicate';

const predicate = toItineraryPredicate((maxDuration) => ({ stops }) => {
  return stops.every(({ duration }) => duration <= maxDuration);
});

export default predicate;
